angular.module('am4').controller('serviceRequestCtrl', function($stateParams, $scope, $rootScope, serviceRequestService, errorService, machineData, type, nonconnected_id) {
    var that = this;

    that.serial = nonconnected_id || $stateParams.id;

    that.submit = function() {
        $scope.isSaving = true;
        var APIPromise;
        if ( type === 'connected') {
            APIPromise = serviceRequestService.postServiceRequest;
        } else {
            APIPromise = serviceRequestService.postNonconnectedServiceRequest;
        }

        return APIPromise(that.serial, {
            description: that.request.description,
            machine: machineData
        })
        .then(function(res) {
            if (res.serviceRequests) {
                $rootScope.$broadcast('requestSubmitted', res.serviceRequests );
            }
        })
        .catch(function(e) {
            errorService.addError('REQUEST_CREATION_ERROR', e);
        })
        .finally(function() {
            $scope.isSaving = false;
            $scope.closeThisDialog();
        });
    };
});



// WEBPACK FOOTER //
// ./src/app/controllers/serviceRequestCtrl.js